import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import TrustPilotImage from '../../../../../fastlane/TrustPilotImage/TrustPilotImage';
import { PATHS } from '../../Hero.constants';

import styles from './HomepageVRM.scss';

export const TrustPilotHero = ({ className }: { className?: string }) => (
  <div className={styles.socialValidationSection}>
    <Link to={PATHS.review}>
      <TrustPilotImage className={cx(styles.trustpilot, className)} />
    </Link>
  </div>
);
